import React from 'react'
import { authContext } from '../../../contexts/AuthContext'
import _ from 'lodash'
import { withTranslation } from 'react-i18next'
import SectionTitle from '../../SectionTitle'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import {
  Autocomplete,
  Checkbox,
  FormControl,
  InputLabel,
  List,
  ListItem,
  ListItemButton,
  MenuItem,
  Select,
  TextField,
  Typography
} from '@mui/material'
import { Button } from '@mui/material'
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined'
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank'
import CheckBoxIcon from '@mui/icons-material/CheckBox'
import DeleteDialog from '../../DeleteDialog'
import CPEditIconButton from '../../Utils/CPEditIconButton'
import CPDeleteIconButton from '../../Utils/CPDeleteIconButton'
import CPText from '../../Utils/CPText'
import Snackbar from '@mui/material/Snackbar'
import Alert from '@mui/material/Alert'
import Permissions from '../Usuarios/Permissions'
import CPSettingsIconButton from '../../Utils/CPSettingsIconButton'
import CPTip from '../../Utils/CPTip'
import { apiUrl } from '../../../config/api'
import {
  listWorkspacesByBrandLabel,
  listWorkspacesByClientId
} from '../../../services/workspaces'

class ClientWorkspaceDialog extends React.Component {
  constructor() {
    super()

    this.state = {
      snackbarInfoOpen: false,
      workspaces: [],
      assignedWorkspaces: []
    }
  }

  static contextType = authContext

  componentDidMount() {
    this.fetchAssignedWorkspaces(this.props.client.id)
    this.fetchWorkspaceList()
  }

  fetchWorkspaceList = async () => {
    let list = await listWorkspacesByBrandLabel()
    this.setState({
      workspaces: list
    })
  }

  fetchAssignedWorkspaces = async (clientId) => {
    let list = await listWorkspacesByClientId(clientId)
    this.setState({
      assignedWorkspaces: _.map(list, 'workspace_id')
    })
  }

  toggleAssignWorkspace = (event, workspaceId) => {
    let url = apiUrl('ToggleAssignClientWorkspace')

    let assignedWorkspaces = this.state.assignedWorkspaces
    if (event.target.checked) {
      assignedWorkspaces.push(workspaceId)
    } else {
      _.remove(assignedWorkspaces, (wid) => {
        return wid == workspaceId
      })
    }
    this.setState({
      assignedWorkspaces: assignedWorkspaces
    })

    fetch(url, {
      method: 'POST',
      body: JSON.stringify({
        workspaceId: workspaceId,
        clientId: this.props.client.id,
        value: event.target.checked ? 1 : 0
      })
    })
      .then((res) => res.json())
      .then((data) => {
        console.log('Toggle successful')
      })
      .catch((error) => console.log(error))
  }

  render() {
    const { t } = this.props

    return (
      <Dialog open={this.props.open} onClose={this.props.onClose}>
        <DialogTitle>{t('Workspaces')}</DialogTitle>
        <DialogContent>
          <Box sx={{ pb: 1 }}></Box>
          <Autocomplete
            multiple
            options={this.state.workspaces}
            disableCloseOnSelect
            disableClearable
            getOptionLabel={(w) =>
              /* EN is required, ES is optional, default to EN */
              window.$lang === 'en'
                ? w.name_en
                : w.name_es
                  ? w.name_es
                  : w.name_en
            }
            value={
              this.state.workspaces.filter((w) =>
                this.state.assignedWorkspaces.includes(w.id)
              ) || null
            }
            ChipProps={{
              onDelete: null
            }}
            renderOption={(props, option) => (
              <li {...props}>
                <Checkbox
                  icon={<CheckBoxOutlineBlankIcon fontSize='small' />}
                  checkedIcon={<CheckBoxIcon fontSize='small' />}
                  style={{ marginRight: 8 }}
                  onChange={(e) => this.toggleAssignWorkspace(e, option.id)}
                  checked={this.state.assignedWorkspaces.includes(option.id)}
                />
                {/* EN is required, ES is optional, default to EN */}
                {window.$lang === 'en'
                  ? option.name_en
                  : option.name_es
                    ? option.name_es
                    : option.name_en}
              </li>
            )}
            renderInput={(params) => (
              <TextField {...params} label={t('Workspaces')} />
            )}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={this.props.onClose}>{t('Close')}</Button>
        </DialogActions>
      </Dialog>
    )
  }
}

export default withTranslation()(ClientWorkspaceDialog)
